import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import RemoveRoundedIcon from '@mui/icons-material/RemoveRounded';
import Checkbox from '@mui/material/Checkbox';
import PropTypes from 'prop-types';
import React, { useId } from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme, { disabled }) => ({
  checkboxBorder: {
    width: 20,
    height: 20,
    borderRadius: 4,
    border: `1px solid ${theme.palette.border.main}`,
  },
  checked: {
    color: theme.palette.background.paper,
    borderRadius: 4,
    fontSize: 18,
    width: 20,
    height: 20,
    border: `1px solid ${theme.palette.border.main}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: disabled ? theme.palette.action.disabledOpacity : 1,
    backgroundColor: theme.palette.primary.main,
  },
  indeterminate: {
    color: theme.palette.background.paper,
    borderRadius: 4,
    fontSize: 18,
    width: 20,
    height: 20,
    border: `1px solid ${theme.palette.border.main}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.primary.main,
  },
}));

// type CheckBoxProps = {
//   onChange: any,
//   indeterminate: boolean,
//   checked: boolean,
//   className: string,
//   disabled: boolean,
// };
function QCheckbox({ onChange, indeterminate, checked, className, disabled, classes: propClasses }) {
  const { classes } = useStyles({ disabled });
  const id = useId();

  return (
    <Checkbox
      id={`q-checkbox-${id}`}
      className={className}
      classes={propClasses}
      disabled={disabled}
      checked={checked}
      indeterminate={indeterminate}
      onChange={onChange}
      checkedIcon={
        <div className={classes.checked}>
          <CheckRoundedIcon fontSize='24px' />
        </div>
      }
      icon={<div className={classes.checkboxBorder} />}
      indeterminateIcon={
        <div className={classes.indeterminate}>
          <RemoveRoundedIcon fontSize='24px' />
        </div>
      }
    />
  );
}

QCheckbox.propTypes = {
  id: PropTypes.string,
  onChange: PropTypes.func,
  indeterminate: PropTypes.bool,
  checked: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  classes: PropTypes.object,

  // ferry
  sx: PropTypes.object,
};
export default QCheckbox;
